import { useFormik } from 'formik';
import { NumericDecimal } from 'presentation/app/components/inputs/numeric-decimal';
import { clearSelectedQuestionOption } from 'presentation/config/store/evaluation-criteria/question-options/question-options-slice';
import { FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import {
  Col,
  Row,
  Form,
  Label,
  Input,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from 'reactstrap';
import * as Yup from 'yup';

import { useQuestionOptions } from '../../../hooks/useQuestionOptions';

interface IModalQuestionOptionsFormProps {
  isOpen: boolean;
  toggle: () => void;
}

export const ModalQuestionOptionsForm = ({
  isOpen,
  toggle,
}: IModalQuestionOptionsFormProps) => {
  const dispatch = useDispatch();
  const { requestUpdateQuestionOption, selectedOption } = useQuestionOptions();

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: selectedOption ? selectedOption?.name : '',
      grade: selectedOption ? selectedOption?.grade : '',
      description: selectedOption ? selectedOption?.description : '',
    },
    validationSchema: Yup.object({
      title: Yup.string().required(),
      grade: Yup.string().nullable(),
      description: Yup.string().nullable(),
    }),
    onSubmit: async (values) => {
      const valuesToSubmit = {
        id: selectedOption.id,
        name: values.title,
        grade: values.grade === '' ? null : Number(values.grade),
        description: values.description,
      };

      requestUpdateQuestionOption(valuesToSubmit, toggle);
    },
  });

  return (
    <Modal
      centered
      isOpen={isOpen}
      backdrop="static"
      keyboard={false}
      modalClassName="fadeInDown"
      toggle={() => {
        toggle();
      }}
      onClosed={() => {
        validation.resetForm();
        dispatch(clearSelectedQuestionOption());
      }}
    >
      <ModalHeader
        className="border-0 border border-bottom border-light p-3"
        toggle={toggle}
      >
        <span>Editar Opção</span>
      </ModalHeader>
      <Form
        onSubmit={(e: FormEvent<HTMLFormElement>) => {
          e.preventDefault();
          validation.handleSubmit(e);
          return false;
        }}
      >
        <ModalBody>
          <Row className="g-4">
            <Col md={8}>
              <Label>Título</Label>
              <Input
                value={validation.values.title}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                name="title"
                invalid={
                  !!(validation.touched.title && validation.errors.title)
                }
              />
            </Col>

            <Col md={4}>
              <Label>Nota</Label>
              <NumericDecimal
                id="grade"
                name="grade"
                allowNegative={false}
                value={validation.values.grade}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
              />
            </Col>

            <Col md={12}>
              <Label>Descrição</Label>
              <Input
                value={validation.values.description}
                onBlur={validation.handleBlur}
                onChange={validation.handleChange}
                name="description"
                type={'textarea'}
              />
            </Col>
          </Row>
        </ModalBody>

        <ModalFooter className="border-0 border border-top border-light p-2">
          <div className="text-end">
            <Button
              className="btn-link text-decoration-underline"
              color="link"
              onClick={toggle}
            >
              Cancelar
            </Button>
            <Button color="primary" type="submit">
              Salvar
            </Button>
          </div>
        </ModalFooter>
      </Form>
    </Modal>
  );
};
